var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{key:_vm.settings.icon,class:_vm.settings.divClass},[_c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon-right":"","icon":_vm.settings.icon,"statistic":_vm.settings.value,"statisticTitle":_vm.settings.label}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }